var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 3H14.5C13.1193 3 12 4.11929 12 5.5V33.5C12 34.8807 13.1193 36 14.5 36H26.5C27.8807 36 29 34.8807 29 33.5V5.5C29 4.11929 27.8807 3 26.5 3Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H15C13.8954 4 13 4.89543 13 6V33C13 34.1046 13.8954 35 15 35H26C27.1046 35 28 34.1046 28 33V6C28 4.89543 27.1046 4 26 4Z",
    fill: "#EEE0AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H26C27.1046 4 28 4.89543 28 6V33C28 34.1046 27.1046 35 26 35H25L15 4Z",
    fill: "#BEAE79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 6.4568C22.6269 6.4568 23 6.1259 23 5.7176C23 5.30942 22.6269 4.97852 22.1667 4.97852H18.8333C18.3731 4.97852 18 5.30942 18 5.7176C18 6.1259 18.3731 6.4568 18.8333 6.4568H22.1667Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon_mobile.99db757f6ef58a64e6496b973c7aadb9.svg";
export { ForwardRef as ReactComponent };